import Format from './format';

const btnCmdAnaViewer = (layoutSt) => (
  Format.isMsLayout(layoutSt)
    || Format.isLCMsLayout(layoutSt)
    || Format.isRamanLayout(layoutSt)
    || Format.is19FLayout(layoutSt)
    || Format.isUvVisLayout(layoutSt)
    || Format.isHplcUvVisLayout(layoutSt)
    || Format.isTGALayout(layoutSt)
    || Format.isDSCLayout(layoutSt)
    || Format.isXRDLayout(layoutSt)
    || Format.is31PLayout(layoutSt)
    || Format.is15NLayout(layoutSt)
    || Format.is29SiLayout(layoutSt)
    || Format.isCyclicVoltaLayout(layoutSt)
    || Format.isCDSLayout(layoutSt)
    || Format.isSECLayout(layoutSt)
    || Format.isGCLayout(layoutSt)
);

const hideCmdAnaViewer = () => false;

const btnCmdAddPeak = (layoutSt) => Format.isMsLayout(layoutSt);

const btnCmdRmPeak = (layoutSt) => Format.isMsLayout(layoutSt);

const btnCmdSetRef = (layoutSt) => !Format.isNmrLayout(layoutSt);

const btnCmdIntg = (layoutSt) => !(Format.isNmrLayout(layoutSt)|| Format.isHplcUvVisLayout(layoutSt) || Format.isLCMsLayout(layoutSt));  // eslint-disable-line

const showIntegSplitTools = (layoutSt) => Format.isHplcUvVisLayout(layoutSt);

// Layouts drawn by a view that honours an inverted y-axis (d3_line, d3_multi). The
// MS bar chart and the LC/MS stack do not, so they get neither the toggle nor the
// inversion -- this decides both.
const showInvertY = (layoutSt) => !(Format.isMsLayout(layoutSt) || Format.isLCMsLayout(layoutSt));

const btnCmdMpy = (layoutSt) => !Format.isNmrLayout(layoutSt);

const btnCmdMpyPeak = (layoutSt, mpySt, curveIdx = 0) => {
  const { multiplicities } = mpySt;
  let smExtextVal = false;
  if (multiplicities) {
    const selectedMultiplicity = multiplicities[curveIdx];
    if (selectedMultiplicity) {
      const { smExtext } = selectedMultiplicity;
      smExtextVal = smExtext;
    }
  }
  return btnCmdMpy(layoutSt) || !smExtextVal;
};

const hideCmdThres = (layoutSt) => Format.isMsLayout(layoutSt);

const btnCmdThres = (thresVal) => !thresVal;

// const hidePanelPeak = layoutSt => Format.isMsLayout(layoutSt);
const hidePanelPeak = layoutSt => !(Format.isSECLayout(layoutSt));  // eslint-disable-line

const hidePanelMpy = (layoutSt) => !Format.isNmrLayout(layoutSt);

const hidePanelCompare = (layoutSt) => !(Format.isIrLayout(layoutSt) || Format.isHplcUvVisLayout(layoutSt) || Format.isXRDLayout(layoutSt));  // eslint-disable-line

const hideSolvent = (layoutSt) => !Format.isNmrLayout(layoutSt);

const showTwoThreshold = (layoutSt) => Format.isCyclicVoltaLayout(layoutSt);

const hidePanelCyclicVolta = (layoutSt) => !Format.isCyclicVoltaLayout(layoutSt);

const Config = {
  btnCmdAnaViewer,
  hideCmdAnaViewer,
  btnCmdAddPeak,
  btnCmdRmPeak,
  btnCmdSetRef,
  btnCmdIntg,
  showIntegSplitTools,
  showInvertY,
  btnCmdMpy,
  btnCmdMpyPeak,
  hideCmdThres,
  btnCmdThres,
  hidePanelPeak,
  hidePanelMpy,
  hidePanelCompare,
  hideSolvent,
  showTwoThreshold,
  hidePanelCyclicVolta,
};

export default Config;
